<div style="background: #ffeeff" class="h-100 overflow-auto crm-scroll">
  <app-sidebar-header (close)="close.emit()" [title]="('integration' | translate) + ' Telegram'"></app-sidebar-header>
  <mat-card style="" class="shadow-none bg-transparent">
    <mat-card-header class="d-flex flex-column bg-white rounded-2 m-3 p-4">
      <div class="d-flex flex-column bg-white rounded-2">
        <div class="d-flex flex-wrap gap-4">
          <div class="icon-logo"><img src="/assets/svgs/integrations/telegram.svg" alt="Telegram logo" /></div>
          <div>
            <h5>{{ 'add_a_phone_number' | translate }}</h5>
            <p>{{ 'you_can_delete_at_any_time' | translate }}</p>
            <div class="d-flex gap-2 flex-wrap">
              <app-phone-field
                (keydown.enter)="addPhone()"
                customClass="h-36"
                [inputValue]="phoneInput"
                (valueChanged)="phoneInput = $event"
              ></app-phone-field>
              <app-button (onChangeClick)="addPhone()" [disabled]="!phoneInput">{{ 'add' | translate }}</app-button>
            </div>
          </div>
        </div>
      </div>
    </mat-card-header>
    @if (true) {
      <mat-card-content class="m-3 p-4 bg-white rounded-2">
        <h5>{{ 'connection_instructions' | translate }}:</h5>
        <div>
          <div>1. {{ 'add_users_who_will_have_access_to_Telegram' | translate }}.</div>
          <div>2. {{ 'go_to_the_Telegram_bot_and_register' | translate }}.</div>
          <div>
            {{ 'the_bot_is_available_at_this_link' | translate }}:
            <a href="https://t.me/{{ environment.telegram.name }}" target="_blank"
              >&#64;{{ environment.telegram.name }}</a
            >
          </div>
        </div>
      </mat-card-content>
    }
    <mat-card-footer class="bg-white rounded-2 m-3 p-4">
      <h5>{{ 'account_settings' | translate }}</h5>
      <mat-divider></mat-divider>
      <div>
        <div class="d-flex gap-4 align-items-end flex-wrap">
          @if (dataSource$ | async; as dataSource) {
            <app-table
              class="w-100"
              [dataSource]="dataSource"
              [visibleColumnKeys]="visibleColumns"
              (onSortChange)="onSortChange($event)"
              (onPaginationChange)="onPaginationChange($event)"
              (onSelectRow)="onAssignUser($event)"
              (menuSelected)="onActionChange($event)"
            ></app-table>
          }
        </div>
      </div>
    </mat-card-footer>
  </mat-card>
</div>

<!--<div>-->
<!--  <div class="d-flex gap-2">-->
<!--    <app-phone-field-->
<!--      [inputValue]="phoneInput"-->
<!--      (valueChanged)="phoneInput = $event"-->
<!--    ></app-phone-field>-->
<!--    <app-button (onChangeClick)="addPhone()" [disabled]="!phoneInput">Додати</app-button>-->
<!--  </div>-->
<!--  <div>-->
<!--    <app-table-->
<!--      *ngIf="dataSource$ | async as dataSource"-->
<!--      [dataSource]="dataSource"-->
<!--      [visibleColumnKeys]="visibleColumns"-->
<!--      (onSortChange)="onSortChange($event)"-->
<!--      (onPaginationChange)="onPaginationChange($event)"-->
<!--      (menuSelected)="onActionChange($event)"-->
<!--    ></app-table>-->
<!--  </div>-->
<!--</div>-->
